import { useState, useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import clsx from 'clsx'
import IconCopy from '@/components/icons/IconCopy'
import { popupNotificationListState } from '@/recoil/Notification'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import { getApiTradingKeyInfo } from '@/utils/authentication'
import './ApiTradingKeyPopup.css'

const ANIMATION_TIME = 200

function KeyInfoBlock({ label, value, onCopy }) {
  return (
    <div className="key-info-block">
      <div className="key-info-label">{label}</div>
      <div className="key-info-value-block">
        <div className="key-info-value">{value}</div>
        <IconCopy className="icon-copy" onClick={onCopy} />
      </div>
    </div>
  )
}

export default function ApiTradingKeyPopup({
  show,
  hidePopupCallback = () => {}
}) {
  const setPopupNotification = useSetRecoilState(popupNotificationListState)
  const [showElement, setShowElement] = useState(false)
  const [active, setActive] = useState(false)
  const [
    {
      accountId,
      orderlyApiKey,
      orderlyApiSecret,
      orderlyTradingApiKey,
      orderlyTradingSecret
    }
  ] = useState(getApiTradingKeyInfo())
  const [, copy] = useCopyToClipboard()

  useEffect(() => {
    if (show) {
      setShowElement(true)
      setTimeout(() => setActive(true), 20)
    }
  }, [show])

  const onCopy = data => {
    copy(data)
    setPopupNotification({
      notification: {
        key: Date.now(),
        status: 'success',
        message: 'Copied'
      }
    })
  }

  const onPopupClose = () => {
    setActive(false)
    setTimeout(() => {
      setShowElement(false)
      hidePopupCallback()
    }, ANIMATION_TIME)
  }

  return (
    <div
      className={clsx('popup-card-overlay', {
        show: showElement,
        active
      })}
    >
      <div className="popup-card api-trading-key-popup">
        <div className="api-trading-key-popup-title">API Trading Keys</div>
        <div className="api-trading-key-popup-subtitle">
          Do not disclose your API keys to anyone to avoid
          <br />
          asset losses in your NEAR wallet.
        </div>
        <div>
          <KeyInfoBlock
            label="Account"
            value={accountId}
            onCopy={() => onCopy(accountId)}
          />
          <KeyInfoBlock
            label="Orderly API Key"
            value={orderlyApiKey}
            onCopy={() => onCopy(orderlyApiKey)}
          />
          <KeyInfoBlock
            label="Orderly API Secret"
            value={orderlyApiSecret}
            onCopy={() => onCopy(orderlyApiSecret)}
          />
          <KeyInfoBlock
            label="Trading API Key"
            value={orderlyTradingApiKey}
            onCopy={() => onCopy(orderlyTradingApiKey)}
          />
          <KeyInfoBlock
            label="Trading API Secret"
            value={orderlyTradingSecret}
            onCopy={() => onCopy(orderlyTradingSecret)}
          />
        </div>
        <div className="popup-card-close-button" onClick={onPopupClose} />
      </div>
    </div>
  )
}
